// Normalize backend User+Solutions into the same shape our components expect.
export function realUserToPerson(u) {
  return {
    id: u.user_id,
    isDemo: false,
    name: u.name,
    role: u.role || "",
    location: u.location || "",
    photo: u.picture || "",
    bio: u.bio || "",
    categories: u.categories || [],
    tools: u.tools || [],
    software_tools: u.software_tools || [],
    links: u.links || [],
    problemsPosted: 0,
    problems: (u.solutions || []).map((s) => ({
      title: s.title,
      description: s.description,
      outcome: s.outcome || "",
      tools: s.tools || [],
      categories: s.categories || [],
      dateSolved: s.date_solved,
    })),
  };
}

export function realProblemToOpen(p) {
  return {
    id: p.problem_id,
    isDemo: false,
    title: p.title,
    category: p.category,
    description: p.description,
    postedBy: {
      name: p.posted_by_name,
      role: p.posted_by_role || "",
      photo: p.posted_by_picture || "",
      personId: p.posted_by_user_id,
    },
    datePosted: (p.created_at || "").slice(0, 10),
    urgency: p.urgency,
    interestedCount: p.interested_count || 0,
  };
}
